module.exports = __webpack_public_path__ + "static/media/d6_logo_teal.ea7dea76.svg";